import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iFinalRankFilterSaveState {
    response: any;
    isLoading: boolean;
    message: string | null;
    backupList: any[];
}

const initialState: iFinalRankFilterSaveState = {
    response: null,
    isLoading: false,
    message: "",
    backupList: [],
};

export const workFlowFinalRankFilterAPI = createAsyncThunk(
    "workFlowFinalRankFilterAPI",
    async (data: {
        workflow_name: string;
        group_name: string;
        library_name: string;
        round: number;
        rank_filter: {
            final_rank_filter: {
                [key: string]: {
                    direction: string;
                    value: number;
                }
            }
        }
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/final-rank-filter-save/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                workflow_name: data.workflow_name,
                group_name: data.group_name,
                library_name: data.library_name,
                round: data.round,
                rank_filter: data.rank_filter
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const workflowFinalSaveReducer = createSlice({
    name: "workflowFinalSaveReducer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(workFlowFinalRankFilterAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(workFlowFinalRankFilterAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
                state.backupList = action.payload.backup_list;
            })
            .addCase(workFlowFinalRankFilterAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});


export default workflowFinalSaveReducer.reducer;